import { type GetPortfolioLabChartItem, PortfolioLabContext } from "$root/functional-areas/portfolio-lab/ctx";
import { useLabSession } from "$root/functional-areas/portfolio-lab/hooks/useLabSession";
import { writeAtom } from "@mdotm/shadcn/legacy/reactivity";
import { useMandatoryContext } from "@mdotm/utils/react-extra";
import { Switch } from "@mdotm/shadcn/mdotm/components";

/**
 * "Show delta" switch shown in the header of the metric-bearing lab charts (Performance and
 * Portfolio metrics). Toggles the per-chart `showDelta` preference on the lab-session charts atom
 * and persists it, so the choice survives reloads like the column state does.
 */
export function ShowDeltaToggle({
	chart,
}: {
	chart: GetPortfolioLabChartItem<"PERFORMANCE"> | GetPortfolioLabChartItem<"TABLE">;
}): React.JSX.Element {
	const ctx = useMandatoryContext(PortfolioLabContext);
	const { saveLabSession } = useLabSession();

	return (
		<Switch
			data-qualifier={`PortfolioLab/ShowDelta(${chart.type})`}
			checked={chart.preference.showDelta}
			onChange={(showDelta) => {
				writeAtom(ctx.charts$, (charts) =>
					charts.map((c) => {
						if (c.uuid === chart.uuid && (c.type === "PERFORMANCE" || c.type === "TABLE")) {
							return { ...c, preference: { ...c.preference, showDelta } };
						}
						return c;
					}),
				);
				saveLabSession();
			}}
		>
			Show delta
		</Switch>
	);
}
